import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { renderToString } from 'react-dom/server';
import suitcss from '../../../../helpers/suitcss';
import Slider from '../../../basics/slider/Slider';
import SliderSlide from '../../../basics/slider/SliderSlide';
import matchMediaConnector from '../../../../containers/service/ServiceMatchMedia';
import connectUI from '../../../basics/ui/UIConnector';

function DashboardWrapper(props) {
  const { children, isMediaS, ui } = props;
  return (
    <div className={suitcss({}, this)}>
      {children && (
        <Slider
          theme="light"
          config={{
            centeredSlides: isMediaS,
            slidesPerView: isMediaS ? 1 : 2,
            spaceBetween: isMediaS ? 24 : 48,
            simulateTouch: isMediaS,
          }}
          pagination={{
            cssDisplay: 'flex',
            alignTop: true,
            renderBullet: (index, className) => renderToString(
              <div className={className}>
                <label htmlFor={`dashboard-navigation-${children[index]?.key}`}>
                  {ui[children[index]?.key]}
                  <input
                    type="radio"
                    name="dashboard-navigation"
                    value={index}
                    id={`dashboard-navigation-${children[index]?.key}`}
                  />
                </label>
              </div>,
            ),
          }}
        >
          {children.map((child, index) => (
            <SliderSlide key={child.key} index={index}>
              {child}
            </SliderSlide>
          ))}
        </Slider>
      )}
    </div>
  );
}

DashboardWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]),
  isMediaS: PropTypes.bool,
  ui: PropTypes.shape({
    myDashboardStatus: PropTypes.string.isRequired,
    myDashboardTariff: PropTypes.string.isRequired,
  }).isRequired,
};

export default compose(
  matchMediaConnector(['isMediaS']),
  connectUI(),
)(DashboardWrapper);
